// round to 2 decimal places
const roundToTwo = (num) => {
  return +(Math.round(num + "e+2") + "e-2");
};

const capitalizeFirstLetter = (string) => {
  if (string) return string.charAt(0).toUpperCase() + string.slice(1);
};
const adaptSubscriptionName = (str) => {
  if (str == "base") return "starter";
  else if (str == "pro") return "individual";
  else if (str == "business") return "serverless";
  else return str;
};

const parseCSVString = (csvString) => {
  try {
    // Skip empty strings
    if (!csvString || csvString.trim() === "") {
      return [];
    }

    // Split the string by newlines and filter out empty lines
    const rows = csvString.split("\n").filter((row) => row.trim() !== "");

    // Convert each row into an object
    const parsedData = rows.map((row) => {
      // Regular expression to match fields considering quoted content
      const regex = /"([^"]*)"|([^;]+)/g;
      const fields = [];
      let match;

      // Extract all fields
      while ((match = regex.exec(row))) {
        // Get either the quoted content (match[1]) or non-quoted content (match[2])
        const value = (match[1] || match[2] || "").trim();
        if (value && value != "") fields.push(value);
      }

      const [question, answer, reasoning, context] = fields;

      return {
        question,
        answer,
        reasoning,
        context,
      };
    });

    return parsedData;
  } catch (error) {
    console.error("Error parsing CSV:", error);
    return [];
  }
};

export default {
  roundToTwo,
  capitalizeFirstLetter,
  adaptSubscriptionName,
  parseCSVString,
};
